import { tabletMediaQueryList } from "../../../core/js/helpers";
import { actions } from "../../../core/js/state-machine";
import {
    componentName,
    defaultProps,
    views,
} from "../../../core/components/side-nav/side-nav-item";
import validateInitialization from "../../../core/js/helpers/validate-initialization";

const SideNavItem = (element, props = {}) => {
    const [success, mergedProps] = validateInitialization({
        componentName,
        defaultProps,
        element,
        props,
        views,
    });
    if (!success) return;

    /**
     * When our anchor is clicked - we need to do some state manipulation for the desired behavior.
     */
    const handleLinkEvent = () => {
        if (toggleStore.getState() === true) {
            // On tablet or less we want to close the nav if we click the link (get more real estate)
            tabletMediaQueryList()
                ? toggleStore.dispatch(actions.collapse())
                : toggleStore.dispatch(actions.expand());
        } else {
            // If our sidenav is collapsed - we need to open it.
            toggleStore.dispatch(actions.expand());
        }
    };

    /**
     * Cleanup method - when our component is disposed, we want to remove any event listeners.
     * @returns
     */
    const dispose = () => {
        return element.removeEventListener("click", handleLinkEvent);
    };

    const { toggleStore } = mergedProps.store;

    element.addEventListener("click", handleLinkEvent);

    const api = {
        element,
        dispose,
    };

    // Assign ourselves to the element.
    element[componentName] = api;

    // Return ourselves incase we are captured in js.
    return api;
};

export default SideNavItem;
